import React from 'react';
import Header from './DashboardHeader';
import Footer from '../Footer';
import InstallBanner from './InstallBanner';

const DashboardLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {



  return (
    <div>
      <Header />
      <main>
        {children}
      </main>
      <Footer />

  
     <InstallBanner />
    </div>
  );
};

export default DashboardLayout;
